import * as Awesomplete from 'awesomplete';
import 'awesomplete/awesomplete.css';

import './autocomplete.scss';

class Autocomplete {
	constructor(el, data, cb) {
		this.el = el;
		this.data = data;
		this.cb = cb;

		this.init();
	}

	init() {
		this.search = new Awesomplete(this.el, {
			list: this.data,
			replace: (suggestion) => {
				this.el.value = suggestion.label;
				if(this.cb) {
					this.cb(suggestion.value);
				}
			}
		});
	
	}

	reset() {
		this.el.value = '';
	}
}

export default Autocomplete;